var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84894 1.1111L8.50727 6.14073L14.1656 1.1111C14.7344 0.605545 15.6531 0.605545 16.2219 1.1111C16.7906 1.61666 16.7906 2.43332 16.2219 2.93888L9.5281 8.88888C8.95936 9.39443 8.0406 9.39443 7.47185 8.88888L0.778104 2.93888C0.505027 2.69669 0.351562 2.36788 0.351562 2.02499C0.351562 1.6821 0.505027 1.35329 0.778104 1.1111C1.34685 0.618508 2.28019 0.605545 2.84894 1.1111Z",
    fill: "#5C5C5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDown);
export default __webpack_public_path__ + "static/media/dropdown-arrow-down.028a2080d1e30c617e29fdb4b758a18a.svg";
export { ForwardRef as ReactComponent };